/**
 * Photos reelles du site (a deposer dans /public/photos/).
 *
 * Principe : chaque emplacement cle du site declare ici un nom de fichier
 * attendu. Tant que le fichier n'existe pas dans /public/photos/, on affiche
 * l'image de secours (stock). Des que le fichier est depose, il est utilise
 * automatiquement et l'appel a images.unsplash.com disparait — aucun code a
 * modifier.
 *
 * Format recommande : WebP, 1600 px de large max, < 250 Ko.
 */

// Vite indexe les fichiers presents dans /public/photos au build.
const localFiles = import.meta.glob("/public/photos/*.{webp,jpg,jpeg,png,avif}", {
  eager: false,
});

const availableNames = new Set(
  Object.keys(localFiles).map((p) => p.split("/").pop() as string),
);

/** Emplacements photo attendus (nom de fichier a deposer dans /public/photos/). */
export const PHOTO_SLOTS = {
  // TODO photo reelle : DJ Val derriere sa regie (Pioneer DJM-A9), mariage.
  djRegie: "dj-val-regie-mariage.webp",
  // TODO photo reelle : vignette "Soirees & Entreprise" (evenement corporate).
  soireeEntreprise: "dj-val-soiree-entreprise.webp",
  // TODO photo reelle : portrait DJ Val.
  portrait: "dj-val-portrait.webp",
  // TODO photo reelle : setup sono + lumieres installe en salle.
  setupSono: "dj-val-setup-sono.webp",
  // TODO photo reelle : piste de danse pleine, mariage en Provence.
  danceFloor: "dj-val-piste-de-danse.webp",
} as const;

export type PhotoSlot = keyof typeof PHOTO_SLOTS;

/**
 * Renvoie l'URL de la vraie photo si le fichier existe dans /public/photos/,
 * sinon l'image de secours fournie.
 */
export function sitePhoto(slot: PhotoSlot, fallback: string): string {
  const file = PHOTO_SLOTS[slot];
  return availableNames.has(file) ? `/photos/${file}` : fallback;
}

/** Vrai si la photo reelle a bien ete deposee. */
export function hasSitePhoto(slot: PhotoSlot): boolean {
  return availableNames.has(PHOTO_SLOTS[slot]);
}
